import { useQuery } from "@tanstack/react-query";
import { Avatar } from "antd";
import Spinner from "components/Spinner";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import AuthService from "services/AuthService";
import HTTPClient from "services/HTTPClient";
import { showErrorToast } from "utils";

interface Monster {
    id: number;
    name: string;
    url: string;
}


export interface Profile {
    id: number;
    username: string;
    firstName: string;
    lastName: string;
    jwt: string;
    isCurrent: boolean;
    avatar?: Monster;
}

function getAvatarURL(profile: Profile) {
    return profile.avatar?.url ?? "https://homieai-assets.s3.amazonaws.com/monster_5_21d645fc0f.svg";
}



const useProfiles = () => {
    const url = `/api/profiles`;
    return useQuery<Profile[]>(['profiles'], async () => {
        return HTTPClient.get().getJSONResult(url)
    });
};

export function AvatarImage({ url }) {
    return <div className="profile-image-container">
        <img className="image img" src={url} alt="" />
    </div>
}


function ProfileCard({ profile }: { profile: Profile }) {
    const [isSetting, setIsSetting] = useState(false)
    let navigate = useNavigate();
    let profileName = profile.firstName || profile.username
    return (
        <div className="profile-card" onClick={async () => {
            setIsSetting(true);
            await AuthService.setToken(profile.jwt);
            navigate("/")
        }}>
            <AvatarImage url={getAvatarURL(profile)} />
            <h5 className="profile-name is-size-5" title={profileName}>
                {isSetting ? <div className="center">
                    <Spinner className="mr-2" />
                </div> : profileName}
            </h5>
        </div>
    )
}

export default function ProfileSelectionPage() {
    const { data, isLoading, error } = useProfiles();

    useEffect(() => {
        if (error instanceof Error) {
            showErrorToast(error.message)
        }
    }, [error])

    if (isLoading || error) {
        return <div className="center profile-selection-page">
            <Spinner className='mt-6' />
        </div>
    }

    console.log(data)

    return (
        <div className="profile-selection-page">
            <div className="center flex-column h-100">
                <h3 className="is-size-3 has-text-white mb-5">
                    Select your profile
                </h3>
                <div className="center">
                    <div className="profiles">
                        {data?.map(p => <ProfileCard key={p.id} profile={p} />)}
                    </div>
                </div>
            </div>
        </div>
    )
}